import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonTitle,
  IonContent,
} from '@ionic/react';

import TrainingSessionsWidget from './TrainingSessionsWidget';

const TrainingSessions: React.FC = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/my/statistics" text="" />
          </IonButtons>
          <IonTitle>Workout History</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen className="training-sessions-page">
        <div className="training-sessions-page__heading">
          <span>Your progress</span>
          <h1>Training sessions</h1>
          <p>Look back at your workouts, exercises, and trained muscles.</p>
        </div>
        <TrainingSessionsWidget variant="page" />
      </IonContent>
    </IonPage>
  );
};

export default TrainingSessions;
